const templateUrl = require('./address.html');

module.exports = {
  bindings: {
    addressId: '<ogFor'
  },
  controller: require('./address.controller'),
  templateUrl: templateUrl
};
